// SPDX-License-Identifier: AGPL-3.0-or-later

import {makeAutoObservable, observable} from 'mobx';

class LobbyRealtimeStore {
	revisionByLobbyId = observable.map<string, number>();
	discoveryRevision = 0;
	/** Lobby IDs removed via gateway (optimistic discovery filter until refetch). */
	removedLobbyIds = observable.set<string>();

	constructor() {
		makeAutoObservable(this, {}, {autoBind: true});
	}

	bumpLobby(lobbyId: string): void {
		const next = (this.revisionByLobbyId.get(lobbyId) ?? 0) + 1;
		this.revisionByLobbyId.set(lobbyId, next);
	}

	bumpDiscovery(): void {
		this.discoveryRevision += 1;
	}

	markLobbyRemoved(lobbyId: string): void {
		this.removedLobbyIds.add(lobbyId);
		this.bumpLobby(lobbyId);
		this.bumpDiscovery();
	}

	clearRemovedLobby(lobbyId: string): void {
		this.removedLobbyIds.delete(lobbyId);
	}

	clearAllRemoved(): void {
		this.removedLobbyIds.clear();
	}

	isLobbyRemoved(lobbyId: string): boolean {
		return this.removedLobbyIds.has(lobbyId);
	}

	getLobbyRevision(lobbyId: string): number {
		return this.revisionByLobbyId.get(lobbyId) ?? 0;
	}
}

export default new LobbyRealtimeStore();
